import { 
    createConsumer, 
    // logger 
  } from "@rails/actioncable"

  // Enable for debugging
// logger.enabled = true;
// Singleton consumer for application
export const consumer = createConsumer();
